import { render, staticRenderFns } from "./update-dict-data.vue?vue&type=template&id=eee79464&scoped=true&"
import script from "./update-dict-data.vue?vue&type=script&lang=ts&"
export * from "./update-dict-data.vue?vue&type=script&lang=ts&"
import style0 from "./update-dict-data.vue?vue&type=style&index=0&id=eee79464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee79464",
  null
  
)

export default component.exports